import {
    collection,
    doc,
    getDocs,
    query,
    where,
    writeBatch,
    serverTimestamp,
    onSnapshot,
} from "firebase/firestore";

import { db } from "./firebase";

/* ---------------------------------- */
/* COLLECTION */
/* ---------------------------------- */

const COLLECTION =
    "csc_slots";

/* ---------------------------------- */
/* SLOT ID */
/* ---------------------------------- */

export function createSlotId(

    courtId,
    date,
    startHour

) {

    const hours =
        Math.floor(startHour);

    const minutes =
        Math.round(
            (startHour - hours) * 60
        );

    const paddedHours =
        String(hours)
            .padStart(2, "0");

    const paddedMinutes =
        String(minutes)
            .padStart(2, "0");

    return (
        `${courtId}_${date}_${paddedHours}-${paddedMinutes}`
    );
}

/* ---------------------------------- */
/* CREATE SLOT DOCUMENT */
/* ---------------------------------- */

function createSlotDocument({

    court,
    date,
    startHour,
    endHour,

}) {

    const slotId =
        createSlotId(

            court.id,

            date,

            startHour
        );

    return {

        /* IDs */

        slotId,

        courtId:
            court.id,

        courtName:
            court.name,

        /* Metadata */

        sport:
            court.sport,

        location:
            court.location,

        date,

        /* Timing */

        startHour,

        endHour,

        duration:
            endHour -
            startHour,

        /* Pricing */

        price:
            court.pricePerHour,

        /* Booking State */

        status:
            "available",

        bookedBy: null,

        bookingId: null,

        bookedAt: null,

        /* Timestamps */

        createdAt:
            serverTimestamp(),

        updatedAt:
            serverTimestamp(),
    };
}

/* ---------------------------------- */
/* CREATE SLOTS FOR DATE */
/* ---------------------------------- */

export async function
    seedSlotsForDate({

        courts,
        date,

    }) {

    if (!courts?.length) {
        return;
    }

    const batch =
        writeBatch(db);

    for (const court of courts) {

        const {

            openingTime,
            closingTime,
            slotDuration,

        } = court;

        const [
            openHour,
            openMinute,
        ] = openingTime
            .split(":")
            .map(Number);

        const [
            closeHour,
            closeMinute,
        ] = closingTime
            .split(":")
            .map(Number);

        const openingMinutes =

            openHour * 60 +

            openMinute;

        const closingMinutes =

            closeHour * 60 +

            closeMinute;

        let currentMinutes =
            openingMinutes;

        while (

            currentMinutes +

            slotDuration

            <=

            closingMinutes

        ) {

            const endMinutes =

                currentMinutes +

                slotDuration;

            const startHour =
                currentMinutes / 60;

            const endHour =
                endMinutes / 60;

            const slot =
                createSlotDocument({

                    court,

                    date,

                    startHour,

                    endHour,
                });

            const slotRef =
                doc(
                    db,
                    COLLECTION,
                    slot.slotId
                );

            batch.set(

                slotRef,

                slot,

                {
                    merge: true,
                }
            );

            currentMinutes +=
                slotDuration;
        }
    }

    await batch.commit();

    console.log(
        `Slots seeded for ${date}`
    );
}

/* ---------------------------------- */
/* GET SLOTS */
/* ---------------------------------- */

export async function
    getSlotsForDate({

        courtId,
        date,

    }) {

    const q = query(

        collection(
            db,
            COLLECTION
        ),

        where(
            "courtId",
            "==",
            courtId
        ),

        where(
            "date",
            "==",
            date
        )
    );

    const snapshot =
        await getDocs(q);

    return snapshot.docs.map(
        (doc) => doc.data()
    );
}

/* ---------------------------------- */
/* REALTIME SLOT LISTENER */
/* ---------------------------------- */

export function
    subscribeToSlots({

        courtId,
        date,
        callback,

    }) {

    const q = query(

        collection(
            db,
            COLLECTION
        ),

        where(
            "courtId",
            "==",
            courtId
        ),

        where(
            "date",
            "==",
            date
        )
    );

    return onSnapshot(

        q,

        (snapshot) => {

            const slots =
                snapshot.docs.map(
                    (doc) =>
                        doc.data()
                );

            callback(slots);
        },

        (error) => {

            console.error(
                "Slot listener failed:",
                error
            );

            callback([]);
        }
    );
}